import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const getAllServiceAgrement = (userData, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.limit) {
    queryParams.append("limit", params.limit);
  }
  if (params.page) {
    queryParams.append("page", params.page);
  }
  if (userData?.designation === "Sales Agent") {
    queryParams.append("createdBy", userData?._id);
  }

  const finalUrl = queryParams.toString()
    ? `${endPoints.getAllServiceAgrement}?${queryParams.toString()}`
    : endPoints.getAllServiceAgrement;

  return Api(finalUrl, null, requestType.GET);
};

const getServiceAgrementById = (id) => {
  return Api(
    `${endPoints.getServiceAgrementById}/${id}`,
    null,
    requestType.GET,
  );
};

const updateServiceAgrement = (id, params) => {
  return Api(
    `${endPoints.updateServiceAgrement}/${id}`,
    params,
    requestType.PUT,
  );
};

const deleteServiceAgrement = (id) => {
  return Api(
    `${endPoints.deleteServiceAgrement}/${id}`,
    null,
    requestType.DELETE,
  );
};

const resendServiceAgrement = (id, payload) => {
  return Api(
    endPoints.resendServiceAgrement.replace(":id", id),
    payload,
    requestType.PATCH,
  );
};

export {
  getAllServiceAgrement,
  getServiceAgrementById,
  updateServiceAgrement,
  deleteServiceAgrement,
  resendServiceAgrement,
};
